import React, { useState, useEffect } from "react";
import AdditionalServices from "./additionalServices";
import { FaTrash } from "react-icons/fa";
import { FiCheck } from "react-icons/fi";
import { Button1, MiniBlock } from "../../../../../common/Buttons";
import moment from "moment";
import {
  copyToClipboard,
  prettyDateFormat,
} from "../../../../../../helpers/Utils";
import { BiMailSend } from "react-icons/bi";
import {
  IconCopy,
  IconExclamation,
  IconTimes,
  IconMessage,
  IconRestore,
} from "../../../../../Layout/Icons";
import { useDispatch } from "react-redux";
import { cancelDocument } from "../../../../../../redux/Actions/orderContractAction";
import { Tooltip, Modal } from "antd";
const { confirm } = Modal;

function AdditionalServicesMain({
  orderId,
  orderId2,
  documentTypeArray,
  order_rows,
  contracts,
  addContract,
  updateContract,
  deleteContractItem,
  deleteContract,
  billing_address,
  errors,
  sendContractEmail,
  firstAddContract,
  firstDeleteContract,
  changeContractItems,
}) {
  const dispatch = useDispatch();
  const [OrderRow, setOrderRow] = useState([]);
  const [DocumentType, setDocumentType] = useState([]);
  const [DocumentPlan, setDocumentPlan] = useState([]);
  const [Open, setOpen] = useState([]);

  const fullName = (firstName, lastName) => {
    if (!firstName) {
      return orderId2;
    }
    return firstName + " " + lastName;
  };

  const addMaster = () => {
    const randomId = Math.floor(Math.random() * 100);
    const variables = {
      id: randomId,
      customer: fullName(billing_address.firstname, billing_address.lastname),
      phone: billing_address.phone,
      email: billing_address.other,
      buy_date: moment(),
      contract_items: [],
      contract_emails: [],
      action_status: "new",
    };

    firstAddContract(variables);
    setOpen([randomId]);
  };
  useEffect(() => {
    let orderRow = [];
    order_rows.forEach((item) => {
      if (item.product_reference !== "{}") {
        orderRow.push({
          value: item.id,
          label: item.product_name,
          product_price: item.unit_price_tax_incl,
          product_reference: item.product_reference,
          manufacturer: item?.product_info?.manufacturer,
        });
      }
    });
    setOrderRow(orderRow);
  }, [order_rows]);

  useEffect(() => {
    let documentType = [];
    let documentPlan = [];
    documentTypeArray.forEach((item) => {
      documentType.push({
        value: item.id,
        label: item.name,
        brands: item.brands,
        prefix: item.prefix,
      });
      item.document_plans.forEach((planItem) =>
        documentPlan.push({
          value: planItem.id,
          label: planItem.name,
          type: planItem.document_type_id,
          document_type_id: planItem.document_type_id,
          cost: planItem.cost,
          percentage: planItem.percentage,
        })
      );
    });
    setDocumentType(documentType);
    setDocumentPlan(documentPlan);
  }, [documentTypeArray]);

  const openMaster = (id) => {
    const currentIndex = Open.indexOf(id);
    const newChecked = [...Open];

    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setOpen(newChecked);
  };

  const onDelete = (item) => {
    if (item.action_status == "new") {
      firstDeleteContract(item.id);
    } else {
      deleteContract(orderId, item.id);
    }
  };

  const cancelDocumentFunc = (item) => {
    let promtCancelDocument = prompt(
      `The reason you want to cancel the document ${item.number} ?`,
      ""
    );

    if (promtCancelDocument) {
      dispatch(cancelDocument(item.id, promtCancelDocument, "order"));
    }
  };

  const status_check = (status) => {
    let val = {
      color: "#BD00FF",
      text: "Valid",
    };
    if (status) {
      val = {
        color: "#EF3824",
        text: "Canceled",
      };
    }
    return val;
  };
  return (
    <div>
      <div className="py-4">
        <div style={{ position: "relative" }}>
          <Button1
            style={{
              position: "absolute",
              top: "-16px",
              left: "50%",
              transform: "translate(-50%, 0px)",
            }}
            text={"Create a new document"}
            option={"plus"}
            onClick={() => addMaster()}
          />
          <hr />
        </div>
      </div>
      {contracts.map((item, index) => {
        const itsOpen = Open.includes(item.id);
        const status = status_check(item.canceled_at);

        return (
          <React.Fragment key={index}>
            <MiniBlock
              color={"#e899ff"}
              action={itsOpen}
              onChange={() => openMaster(item.id)}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div style={{ width: "30%" }}>{item.customer}</div>
                <div style={{ width: "20%" }}>
                  {item.created_at && (
                    <div
                      className="d-flex align-items-center"
                      style={{
                        color: status.color,
                      }}
                    >
                      {status.text}
                      {item.canceled_at ? (
                        <>
                          <Tooltip
                            placement="top"
                            title={
                              <div className="text-center">
                                <div>{item.reason}</div>
                                <div
                                  className="cursor-pointer"
                                  onClick={() => {
                                    copyToClipboard(item.number);
                                  }}
                                >
                                  {item.number}
                                  <IconCopy className="text-sm cursor-pointer ml-2" />
                                </div>
                              </div>
                            }
                          >
                            <IconMessage
                              className="mx-2 text-base"
                              fill={status.color}
                            />
                          </Tooltip>
                          <Tooltip placement="top" title="Uncancel">
                            <IconRestore
                              className="text-base text-primary"
                              onClick={() =>
                                confirm({
                                  title: "Are you sure?",
                                  icon: (
                                    <IconExclamation className="text-primary" />
                                  ),
                                  content:
                                    "You will not be able to undo this action",
                                  onOk() {
                                    dispatch(
                                      cancelDocument(item.id, "", "order")
                                    );
                                    console.log("OK");
                                  },
                                  onCancel() {
                                    console.log("Cancel");
                                  },
                                })
                              }
                            />
                          </Tooltip>
                        </>
                      ) : (
                        <Tooltip placement="top" title="Cancel document">
                          <IconTimes
                            color={status.color}
                            className="text-sm ml-1"
                            onClick={() => cancelDocumentFunc(item)}
                          />
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>
                <div style={{ width: "20%" }}>{item.user_title}</div>
                <div style={{ width: "20%" }}>
                  {prettyDateFormat(item.created_at)}
                </div>
                <div style={{ width: "10%" }}>
                  {item?.contract_emails?.length > 0 && (
                    <BiMailSend className="text-success" />
                  )}
                  {item.editable ? (
                    <FiCheck className="text-success ml-2" />
                  ) : (
                    item.contract_items.length == 0 &&
                    item.contract_emails.length == 0 && (
                      <FaTrash
                        className="ml-2"
                        title="Ištrinti"
                        style={{ cursor: "pointer", color: "#e1e1e1" }}
                        onClick={() => onDelete(item)}
                      />
                    )
                  )}
                </div>
              </div>
            </MiniBlock>
            {itsOpen && (
              <React.Fragment key={index}>
                <AdditionalServices
                  DocumentType={DocumentType}
                  DocumentPlan={DocumentPlan}
                  addContract={addContract}
                  updateContract={updateContract}
                  deleteContractItem={deleteContractItem}
                  orderId={orderId}
                  new={item.created_at ? false : true}
                  OrderRow={OrderRow}
                  item={item}
                  index={index}
                  errors={errors}
                  email={billing_address.other}
                  orderId2={orderId2}
                  sendContractEmail={sendContractEmail}
                  setOpen={setOpen}
                  Open={Open}
                  changeContractItems={changeContractItems}
                />
              </React.Fragment>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default AdditionalServicesMain;
